import { render, staticRenderFns } from "./SolutionsConsultancy.vue?vue&type=template&id=aa45e0e6&scoped=true&"
import script from "./SolutionsConsultancy.vue?vue&type=script&lang=js&"
export * from "./SolutionsConsultancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa45e0e6",
  null
  
)

export default component.exports